import { NgModule } from "@angular/core";

import { ImageModule } from "@intocare-medapp/image/image.module";

import { WoundCareOverviewComponent } from "./overview.component";
import { WoundCareListComponent } from "./list/wound-care-list.component";
import { WoundCareItemComponent } from "./item/wound-care-item.component";
import { SharedModule } from "../../shared/shared.module";

@NgModule({
	imports: [SharedModule, ImageModule],
	declarations: [WoundCareOverviewComponent, WoundCareListComponent, WoundCareItemComponent],
	exports: [WoundCareOverviewComponent],
})
export class WoundCareOverviewModule {}
